<ngx-dropzone
    id="dropzone"
    class="w-full h-full"
    [ngClass]="{
        'border border-danger': !files().length && isRequired()
    }"
    [accept]="extensionsString()"
    [disabled]="isDropzoneDisabled()"
    (click)="onDropzoneClick()"
    (change)="onFileAdd($event)">
    <ngx-dropzone-label>
        <div class="flex flex-col items-center">
            <div class="mb-6">
                <div class="flex items-center mb-2">
                    <i class="pi pi-download dropzone-icon mr-2"></i>
                    <p
                        class="font-bold mb-0"
                        style="font-size: 1.2rem">
                        Drop valid file(s) here or click to upload
                    </p>
                    <div></div>
                </div>
                <p class="mb-0">*File sizes large than 20MB will not be accepted</p>
            </div>

            <div class="max-w-[50%] flex justify-between flex-wrap">
                @for (ext of extensions(); track ext) {
                    <kno2-chip
                        class="mx-2"
                        [label]="ext" />
                }
            </div>
        </div>
    </ngx-dropzone-label>

    @for (file of files(); track file) {
        <ngx-dropzone-preview
            [removable]="true"
            (removed)="onFileRemove(file)"
            class="w-full mb-2"
            style="max-height: 20px">
            <ngx-dropzone-label>
                <span class="font-bold">{{ file.name }}</span>
                {{ file.size | fileSize }}
            </ngx-dropzone-label>
        </ngx-dropzone-preview>
    }
</ngx-dropzone>
